import React from "react";
import { Card, Form, Row, Col, Button, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const ServicesSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value
    });
  };

  const handleFileUpload = async (field, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleChange(field, res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  const handleServicesChange = (index, field, value) => {
    const services = [...data.services];
    services[index][field] = value;
    handleChange("services", services);
  };

  const handleAddService = () => {
    const services = [...data.services];
    services.push({ id: Date.now().toString(), title: "" });
    handleChange("services", services);
  };

  const handleRemoveService = (index) => {
    const services = [...data.services];
    services.splice(index, 1);
    handleChange("services", services);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Services Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading}
                  onChange={(e) => handleChange('heading', e.target.value)}
                  placeholder="Enter heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Background Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] && handleFileUpload('backgroundImage', e.target.files[0])
                  }
                />
                {isUploading && (
                  <div className="text-muted small mt-1">Uploading...</div>
                )}
                {data.backgroundImage && (
                  <div className="mt-2">
                    <Image src={data.backgroundImage} thumbnail style={{ maxWidth: "200px" }} />
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6>Services</h6>
            <Button variant="outline-primary" size="sm" onClick={handleAddService}>
              Add Service
            </Button>
          </div>

          {data.services.map((service, index) => (
            <div key={index} className="border rounded p-3 mb-3 bg-light-subtle">
              <Row>
                <Col md={10}>
                  <Form.Control
                    type="text"
                    placeholder="Service title"
                    value={service.title}
                    onChange={(e) => handleServicesChange(index, 'title', e.target.value)}
                  />
                </Col>
                <Col md={2}>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleRemoveService(index)}
                  >
                    Remove
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
        </Card.Body>
      )}
    </Card>
  );
};

export default ServicesSection;
